import { Price } from 'src/components/Price/Price'
import { Text } from 'src/components/Text/Text'

import styles from './CartLineItemPrice.module.scss'

import type { MoneyV2 } from 'src/data/graphql-generated'
import type { CalculatedPrices } from 'src/types/Product'

interface CartLineItemPriceProps {
  itemPriceObjects: CalculatedPrices
}

export const CartLineItemPrice = ({ itemPriceObjects }: CartLineItemPriceProps) => {
  const { price, priceBeforeDiscount, compareAtPrice } = itemPriceObjects

  const itemHasDiscount = priceBeforeDiscount && price.amount !== priceBeforeDiscount.amount

  const hasStrikeThruPrice = !!compareAtPrice || itemHasDiscount
  const strikeThruPrice = itemHasDiscount ? priceBeforeDiscount : compareAtPrice

  return (
    <Text bold right className={styles.priceContainer}>
      {hasStrikeThruPrice ? (
        <>
          <Price price={strikeThruPrice as MoneyV2} className={styles.oldPrice} data-testid="compare-at-price" />
          <br />
          <strong className={styles.newPrice} data-testid="price">
            <Price price={price} />
          </strong>
        </>
      ) : (
        <strong>
          <Price price={price} />
        </strong>
      )}
    </Text>
  )
}
